/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_Edit_SplitInputs */

const en_ui_studio_marker_edit_split = /** @type {(inputs: Ui_Studio_Marker_Edit_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit split point`)
};

const de_ui_studio_marker_edit_split = /** @type {(inputs: Ui_Studio_Marker_Edit_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilungspunkt bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit split point" |
*
* @param {Ui_Studio_Marker_Edit_SplitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_edit_split = /** @type {((inputs?: Ui_Studio_Marker_Edit_SplitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_Edit_SplitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_edit_split(inputs)
	return de_ui_studio_marker_edit_split(inputs)
});